import type { Menu } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { CategoryMenu, CategoryMenuItem } from '@eliadmin/core/src/components/header/category-menu';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export type HeaderMenuProps = {
  className?: {
    root?: string;
    wrapper?: string;
  };
  menu: Menu[];
};

export function HeaderMenu(props: HeaderMenuProps) {
  return (
    <div
      className={cn(
        'flex max-w-full flex-wrap items-center gap-4',
        'ea-header-menu',
        props.className?.wrapper,
      )}
    >
      {props.menu.map(menuItem => {
        return (
          <CategoryMenu key={menuItem.name} className={cn('ea-header-menu', props.className?.root)}>
            {menuItem.fields?.map(item => {
              return <CategoryMenuItem key={item.path} href={item.path} title={item.name} />;
            })}
          </CategoryMenu>
        );
      })}
    </div>
  );
}
